document.addEventListener('DOMContentLoaded', function() {

    var newSlider = {
        speed: 500,
        current: 0,
        el: document.getElementsByClassName('js_news')[0],
        slides: document.querySelectorAll('.news__article'),
        moving: false,
        paginator: document.getElementsByClassName('news__pagination')[0],

        jumpTo: function(i) {
            this.moving = true;
            var self = this;

            this.slides[this.current].classList.add('leaving');

            this.paginator.querySelectorAll('.news__pagination-link').forEach(function(page) {
                page.classList.remove('news__pagination-link--active');
                if (page.dataset.slide == i) {
                    page.classList.add('news__pagination-link--active');
                }
            });

            setTimeout(function() {
                self.slides[self.current].classList.remove('news__article--current');
                self.slides[self.current].classList.remove('leaving');
                self.current = i;
                self.slides[self.current].classList.add('news__article--current');
                self.slides[self.current].classList.add('entering');

                setTimeout(function() {
                    self.slides[self.current].classList.remove('entering');
                    self.moving = false;
                }, self.speed);
            }, this.speed);

        },

        init: function() {
            var self = this;

            this.slides.forEach(function(slide, i) {
                var el = document.createElement('div');
                el.dataset.slide = i;
                el.classList.add('news__pagination-link');

                if (i == 0) {
                    el.classList.add('news__pagination-link--active');
                }

                el.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (!self.moving) {
                        self.jumpTo(i);
                    }
                });

                self.paginator.appendChild(el);
            });
        }
    };

    newSlider.init();

});
